import 'core-js/es';
import 'core-js/features/url-search-params';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './components/App/App';
import './fonts.scss';
import './index.scss';
import {DataLayerInfoProvider} from './contexts/DataLayerContext';
import {PreviousPathProvider} from './contexts/PreviousPathContext'
import { createRoot } from 'react-dom/client';

const container : HTMLElement = document.getElementById('app')!;
const root = createRoot(container);
root.render(
<Router>
    <PreviousPathProvider>
      <DataLayerInfoProvider>
        <App />
      </DataLayerInfoProvider>
    </PreviousPathProvider>
</Router>
);